/* eslint-disable padded-blocks */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Cookies from 'js-cookie';

import uiActions from '../../../redux/actions/uiActions';

const SemesterSwitcher = ({
  data, setCurrentGroup, anchorEl, handleMenuClose, id, semester, _currentGroup,
}) => {
  useEffect(() => {
    const currentGroup = Cookies.get('currentGroup') || _currentGroup;
    if (currentGroup) {
      setCurrentGroup(currentGroup);
    } else {
      for (let i = 0; i < data.length; i += 1) {
        if (semester === data[i].semester) {
          setCurrentGroup(i);
          Cookies.set('currentGroup', i, { expires: null }, { secure: true }, { sameSite: 'strict' });
        }
      }
    }
  }, []);

  return (
    <Menu
      anchorEl={anchorEl}
      id={id}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
    >
      { data.map((item, i) => (
        <MenuItem
          onClick={(e) => {
            setCurrentGroup(e.target.value);
            Cookies.set('currentGroup', e.target.value, { expires: null }, { secure: true }, { sameSite: 'strict' });
            handleMenuClose();
          }}
          value={i}
          key={item._id}
        >
          {item.name}
        </MenuItem>
      ))}
    </Menu>
  );
};

SemesterSwitcher.defaultProps = {
  anchorEl: null,
};

SemesterSwitcher.propTypes = {
  anchorEl: PropTypes.any,
  data: PropTypes.array.isRequired,
  setCurrentGroup: PropTypes.func.isRequired,
  _currentGroup: PropTypes.number.isRequired,
  handleMenuClose: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  semester: PropTypes.any.isRequired,
};

function mapState(state) {
  const { data } = state.group;
  const { currentGroup } = state.ui;
  const { semester } = state.user.userData;
  data.sort((a, b) => a.semester < b.semester);
  return {
    data, _currentGroup: currentGroup, semester,
  };
}

const actionCreator = {
  setCurrentGroup: uiActions.setCurrentGroup,
};

export default connect(mapState, actionCreator)(SemesterSwitcher);
